import { FileRoutesByTo } from '@/routeTree.gen';
import { Flex, Text } from '@mantine/core';
import { IconProps } from '@tabler/icons-react';
import { Link, useRouterState } from '@tanstack/react-router';
import { ComponentProps, createElement, FunctionComponent } from 'react';
import styles from './styles.module.css';

type NavItemProps = Omit<ComponentProps<typeof Link>, 'to'> & {
	to: keyof FileRoutesByTo;
	label: string;
	icon: FunctionComponent<IconProps>;
	additionalActivePaths?: string[];
};

export const FooterNavItem = ({ label, icon, additionalActivePaths, ...props }: NavItemProps) => {
	const { location } = useRouterState();
	let active = props.to && location.pathname.startsWith(props.to);

	if (!active && additionalActivePaths) {
		for (const path of additionalActivePaths) {
			if (location.pathname.startsWith(path)) {
				active = true;
				break;
			}
		}
	}

	return (
		<Link {...props} className={`${styles.link} ${active ? styles.activeLink : ''}`}>
			<Flex direction="column" align="center" justify="center" h="100%" w="76px">
				{createElement(icon, { className: styles.icon })}
				<Text size="sm" className={styles.label}>
					{label}
				</Text>
			</Flex>
		</Link>
	);
};
